export const FreightPackageTypesKey = 'freight-package-types';
export const FreightOrderKey = 'freight-order';